export const carPricePercentage = {
    '2572e2b0-76b5-41c5-834c-ec0fdeeb623c': 15,
    'bc28067d-9a52-4a44-85d6-be3fad6e624f': 13,
    '610f0d56-2048-42ba-ab15-55932fce2fcb': 15,
    'c2ce50aa-4e3c-423a-8237-8ddbd677f99e': 17,
    'f3222279-3ff6-487f-84d1-76f530b2c208': 12,
    'd0f232aa-dd32-47cb-8d18-d0c2293caec2': 13,
    'fd318649-7223-4acd-9875-47858d5c7f8a': 13,
    '0f891cc8-6617-42e0-beae-f346b780f777': 19,
    'e22fc546-8b2c-444b-9609-ddfad57814f4': 17,
    'beec49ad-64d1-4a1f-a571-957855928601': 13,
    '2d5ecc3b-9b05-47b6-828a-9352ef130eb7': 20,
    'eec4f13e-3acd-4e27-aad5-ac543f802a7c': 13,
    '514919d2-3275-46ce-b786-bb5cd27bfb93': 21,
    'f26e3320-15e9-4f7c-8bcb-130dd84157be': 19,
    'fffe33cb-45e1-4c14-8b0b-cba89ed0c295': 13,
    'c718866f-972a-4de2-9a73-b8d342c9dedc': 13,
    '50650eff-2351-4de2-9d6d-6c99e8bca4df': 13,
    'd5832f8b-671c-44a1-8163-75c5c429cf76': 13,
    '8de5b301-7b3b-4793-b181-c95e598ffc28': 12,
    'c1c88e7b-15c5-4bc0-9e0d-95ece4a041fe': 11,
    '575f53b1-be73-4d31-a453-536c22ca9bbf': 13,
    '4813c1d7-942b-4ee5-8ed9-864c88b8026b': 13,
    'f37ab3c6-e410-4e9d-858d-346a77dd67e6': 18,
    'bb9cd42b-714f-497b-ab5e-3e7ceb2e1697': 13,
    'fab8c6b5-565c-46f7-86be-7108101f0bb5': 11,
    'ef5ddee8-0811-456a-b496-6a2011f29979': 20,
    '213c7832-46fa-4803-ade3-2e9729d14f52': 11,
    'c7dfa447-afd3-4c40-9492-2f4fed2bde00': 18,
    '3d2ea223-5c87-44e2-af0d-94279f782d09': 10,
    'b1a07e18-c616-4cca-94f7-1737bb40e26f': 17,
    'de558f4c-8eed-4d3d-923b-2e6a6e7f7011': 22,
    'c7f2faed-ebbd-49f3-a1fd-5f228a1999d2': 14,
    '2ab72257-dc56-4d9b-b3b4-d72594ca1e93': 13,
    '25444d42-b864-404e-b81d-ba2fe11cac0f': 13,
    '70991641-348a-48e3-a45c-3aed848f7047': 16,
    '0d471e28-2f5b-4cdc-867e-3337a448c553': 23,
    '912168b7-84a6-4769-8c64-de2aee4ea0b8': 13,
    '9a8aa4b3-fbc1-42a8-b2f2-f9ed5247fb88': 25,
    '7a2837a0-99dd-498d-a335-b8a3c3955593': 15,
    '1525ced7-88a0-447b-9d60-9b26c741422d': 15,
    'd0b5284c-f5cf-414d-9fa8-3871ea54f31a': 11,
    'aac623f8-f8fa-49f6-a8a3-8f2d3164fb09': 13,
    '4eec5dfb-df1c-484f-9e23-8a0f64de13bb': 12,
    '1216bc00-c4a1-479f-9486-aeee469f35cc': 13,
    '90158a29-e2b5-4816-bd50-9545f5392675': 13,
    'b5758bc9-b433-4c0b-9c27-833f67414942': 23,
    '23724325-ea9b-4106-b129-896ec02379aa': 13,
    'a5d02263-4c87-41c0-af70-97deb5ff3199': 24,
    '5bf3b6d0-c97a-4064-9931-4e0db60f6e15': 14,
    'be686c66-afde-4b32-ab99-9ea2235089ac': 13,
    'e12fbe64-624c-4421-b0eb-3b02116d2fd3': 13,
    'ca748983-8e87-4684-a258-aec987eeae37': 15,
    '0d389038-de10-4d8c-9ad7-158b1d59cb00': 9,
    '6ddecb4c-5b75-48c5-b4b4-a3b992b4be02': 10,
    '92726809-645c-4625-867e-ef3f6f702bbd': 20,
    '4d3e9c26-587e-4faf-bd97-3db4e50c4b2d': 16,
    '18b95656-ae91-464c-9b7d-6d647d85aa39': 22,
    '39935dca-5681-463f-b6af-17185a2f9638': 16,
    '9e82faf6-bee4-42c1-80dd-c93f2127569f': 15,
    'e77cc44b-6eb7-4b91-8ea4-38c88c92c098': 17,
    'f3843f08-7c6e-42a3-bcdf-97bd7182960a': 19,
    '860886b5-5ef8-461c-b0f7-77fc59e9c13e': 18,
    '61490f9e-fc86-4da7-9fd1-3aab016c2690': 12,
    '0bb13e5b-3bf9-4e07-8b00-3a739dd5ced1': 13,
    '618877f2-3027-4038-9385-5149b80fbee5': 14,
    '31ee9bc4-fa0a-4780-a6b7-f591ace5e4e0': 16,
    '2e67ae90-9386-4241-939b-3656b96c8100': 13,
    'c5a01739-70a4-47cb-aaf3-282a55641c31': 30,
    '9cfc777b-2f0e-4cab-91c0-1e7000884c78': 12,
    'ce47beca-1890-436c-901f-1e16ed5f2528': 11,
    '32453887-a45d-47a1-89e0-167d30eefdb9': 18,
    '195844a1-16f9-41a1-bfa0-0939afab4956': 10,
    '280b292f-6200-4d3a-a751-e3949a43e755': 13,
    '675f82c3-0047-4a85-9ed4-90e8f1ad2c1b': 16,
    'c5157721-6eff-4194-9279-ca2848f43218': 16,
    'c2905bcd-f8ea-4ea6-ba23-228137ef450c': 10,
    '9bc833d1-a36f-40ee-8a75-159670bfc804': 13,
    '4f83473b-a906-4e36-a35b-86090292c533': 17,
    '9ea2dcbe-6392-45e5-9d19-3ded3e7213c6': 17,
    'c7d371b3-6043-4bd9-b575-f01813003464': 19,
    'f4e80fc2-264c-41b3-afea-7bfbc391071e': 13,
    '8901d448-6faf-4e9e-a228-69e3e3375da4': 23,
    'c1eb2f23-f9c3-48d1-a691-f7c46a1cd8d4': 14,
    'f5f54075-22c9-410c-899b-24834c0ab872': 14,
    '4e3a6712-7abe-492b-a258-7cfee36d765b': 13,
    'c020140f-3e82-4d76-a873-97a9d7c99701': 15,
    '642a4e22-f7cc-485d-8b62-0796a8e1a00a': 9,
    'f733d20d-8c57-494f-a9d0-7ffb40eedc26': 11,
    '4cf2a16e-1c4f-4dba-8191-34f5f55eb454': 19,
    '3e284a72-2e4d-4885-8935-05f4a5cfe489': 9,
    '6a3d876d-e7b6-405f-ba4c-d102955a393e': 14,
    '258e7066-cacd-4cdf-9cb4-d619fee89fa8': 17,
    '240f3782-d8f4-480d-9c1e-e02dc7da4130': 13,
    '2de44ca4-fa0b-4c6d-af36-6f0b7d94e9a7': 24,
    '8a19c7d4-4c54-48a2-8ca1-03ff51cae10c': 28,
    '4c97bb22-0147-4509-b330-cf4cbb03b148': 16,
    '37fe3a72-d06e-413f-9ba0-8e509988bce1': 13,
    'e6824dce-954a-46eb-8a1d-c3baaf863d18': 13,
    '164ae4ae-4867-4047-8ae8-7723e1adb945': 18,
    'd5725cd7-096a-4e93-b44c-35ba07c9569a': 15,
    'a8723e51-80e9-4afd-9b3a-0c0f43be28ac': 29,
    '9a0622e2-7200-48ea-bb3d-c0aacc03930a': 18,
    'cd43787e-ded6-4a44-b09c-d3eade792af9': 13,
    '836ae430-4592-460a-a1b3-907c8516a707': 20,
    '8e5da4ac-80b6-4092-abb0-49614cb9d1b0': 29,
    '52f81879-3acd-434f-9be2-1dd5b744aa89': 13,
    '54c62490-6979-4134-92cc-b345e6a9689c': 19,
    '8a5b9eff-d562-478e-b5e7-556c44288478': 13,
    '02a4d630-6298-4c9f-a9be-79e0552bb2b8': 15,
    'a338ff26-51ec-455c-8307-a598c7aaef71': 11,
    '2e1829b3-5450-4392-977b-15276092d9dd': 17,
    '8fd03859-1b7d-47f5-a0ea-1c221aa0acfb': 16,
    '30f0cfc3-51d3-448b-ac3a-7c73b4676cb1': 25,
    '911d34d7-af0a-487a-b3a0-cce92ae4062b': 22,
    'a8c452f5-ee6f-492b-aa6b-cd98bd1bcdb3': 0,
    '79928d4e-de03-402d-b5e9-71102706ff99': 18,
    'aa15fae0-4cab-41eb-92f1-7ce9a0d75aad': 18,
    '7a300fb4-ffa6-4cb3-818c-0fb316cfd03b': 23,
    '77200b53-55d7-4232-b69a-161f0683974b': 17,
    '6c8ae028-752b-43b8-8cb0-a9a508a863ed': 14,
    '01ee7d1d-0d81-4b3d-ab9a-d8e1c7536d34': 17,
    '4e33df2a-79f2-419e-98af-b5711f6fa3f5': 25,
    'f64d0715-e7a4-47d9-9b2e-98c0e757b3a5': 24,
    '5955c534-be22-43b0-91bb-2f2167163856': 24,
    'e93ca4da-e0f9-4538-b398-3342e0b2a6d6': 22,
    'cb42deac-01da-437d-ae2e-a9238dd13e15': 23,
    'e1b9b6f1-4b38-4021-a436-f944a5993b49': 29,
    '99cefd62-e2bd-4bbc-913b-a373a7820a97': 14,
    'df6d8aa8-9288-44e0-baa5-eb05aa9fab47': 17,
    '10fd2158-1feb-4af5-83b7-b16a27853ba6': 19,
    '96bbcdef-8c58-404a-8b5f-5fe5d97ddd00': 22,
    '71661029-d7a9-4d03-9126-5ebb10dae044': 21,
    '511eed7b-e3ef-467e-b134-2519c048cd0d': 21,
    '266c2522-e78b-44b4-99c2-35c6694d23a9': 13,
    '17c29891-d492-480d-b820-22c08ad6849c': 15,
    'e0453e93-c546-424e-ad3a-2b5914b5e76f': 30,
    'e54be12d-e656-4be0-a325-e34c2bd22f62': 15,
    'a7b71396-366d-443a-855e-6595a13a66fa': 22,
    '15d3f458-b963-4577-8698-157b23341ea8': 15,
    '0453413a-df64-41e8-9a36-4fb56c299c38': 12,
    '7a65d71f-6bd4-47dd-8248-20c65e682428': 16,
    '2e0a73b9-98e2-431d-9b8a-28222e922337': 18,
    'f0398743-7626-4245-be82-b1a8dad04613': 30,
    '841e1686-546c-426d-a71a-e73c37b04aba': 13,
    'a6103da7-89e4-450e-8d34-2e8e25545fa6': 26,
    'f99fb838-a912-4a4f-bdaa-56a40ad80026': 13,
    '46ab41d6-af23-4509-b581-2ee4959f6438': 18,
    '44d66759-4f66-40ba-9f5e-fbed35adb6cb': 20,
    '9e1d3dec-355c-474d-aac8-62e21f6afbe0': 15,
    '2d6e0401-67e8-4bac-9668-9c58ad45a483': 21,
    'fecbb4c1-01bc-4b77-99c8-2695682c3be9': 10,
    'b3e28273-d2ea-4cbd-9b60-8d055168b2d0': 11,
    'ee22b0bd-dc9c-4f66-8e61-5d9b58047cac': 11,
    '56539e90-0191-4292-92e8-4f23c2e64cf1': 30,
    '14442ad8-692c-4afa-91de-1e90537804e1': 13,
    '965c3494-81a3-4189-8ba2-e0135e02d0fe': 25,
    'bc33a609-f13f-4f47-9c4f-d24918c73af7': 2,
    '495fad2c-b904-4887-9e9f-a733e4db9753': 14,
    'd9bbbacf-805e-415d-bb80-05ba21713672': 13,
    '77eaed2e-eea0-40b0-9ceb-afdb5aa6f748': 11,
    '36106f97-8f32-4a0e-93c7-36cbaeb73a1c': 13,
    'bfb679f0-b33a-4ad2-8c42-ed3487899fa2': 20,
    'e3bac195-0930-4ed7-b1db-34fa305a33a6': 6,
    '70ecd8e7-a276-41ff-b0f1-0a8c4515c13f': 17,
    'a8ac0501-959f-42db-8bc1-294b7233bd59': 10,
    '68756095-4de4-4324-8a41-6b5848af0c2f': 1
};